// extracted by mini-css-extract-plugin
export default {"tiles_container":"tiles_container___tRjZz","tile":"tile___VLPvR","tile_text":"tile_text___xLYmM"};